// extracted by mini-css-extract-plugin
export default {"container":"Navigation_container__JL5NV","right":"Navigation_right__YiJIH","left":"Navigation_left__k-4uT","logo":"Navigation_logo__xl-h2","link":"Navigation_link__Zt5jN"};